module.exports = __webpack_public_path__ + "img/148ne.877bfabd.svg";